export enum UNITS_TABLE_COLUMNS {
    NAME = 'Name',
    CODE_CALL = 'Code_call',
    DESCRIPTION = 'Description',
    N_CONTACTS = 'N_Contacts',
    ACTIONS = 'Actions',
}

export const UNITS_DEFAULT_SORT_COLUMN = UNITS_TABLE_COLUMNS.NAME;
export const UNITS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const UNITS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const UNITS_PAGE_DEFAULT_SIZE = 20;
export const UNITS_MAX_MEMORY_SIZE = 3000;

export const UNITS_TABLE_HEADER = [
    UNITS_TABLE_COLUMNS.NAME,
    UNITS_TABLE_COLUMNS.CODE_CALL,
    UNITS_TABLE_COLUMNS.DESCRIPTION,
    UNITS_TABLE_COLUMNS.N_CONTACTS,
    UNITS_TABLE_COLUMNS.ACTIONS,
];
